export const CE_MODAL_CHANGE_HTML_EDITOR_OPEN =
  "CE_MODAL_CHANGE_HTML_EDITOR_OPEN";
export const ceModalChangeHtmlEditorOpen = (clientContentID) => ({
  type: CE_MODAL_CHANGE_HTML_EDITOR_OPEN,
  client_content_id: clientContentID,
});

export const CE_MODAL_CHANGE_HTML_EDITOR_SAVE =
  "CE_MODAL_CHANGE_HTML_EDITOR_SAVE";
export const ceModalChangeHtmlEditorSave = () => ({
  type: CE_MODAL_CHANGE_HTML_EDITOR_SAVE,
});

export const CE_MODAL_CHANGE_HTML_EDITOR_CONFIRM =
  "CE_MODAL_CHANGE_HTML_EDITOR_CONFIRM";
export const ceModalChangeHtmlEditorConfirm = () => ({
  type: CE_MODAL_CHANGE_HTML_EDITOR_CONFIRM,
});

export const CE_MODAL_CHANGE_HTML_EDITOR_CANCEL =
  "CE_MODAL_CHANGE_HTML_EDITOR_CANCEL";
export const ceModalChangeHtmlEditorCancel = () => ({
  type: CE_MODAL_CHANGE_HTML_EDITOR_CANCEL,
});
